var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGovernorPersonal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3998 10.2642C15.3503 10.9743 16.1998 12.7624 16.1998 13.8641C16.1998 14.2073 15.9494 14.4856 15.6405 14.4856H15.2998M11.6998 7.35324C12.3147 6.99755 12.7284 6.33274 12.7284 5.5713C12.7284 4.80987 12.3147 4.14506 11.6998 3.78937M2.35913 14.4856H12.2119C12.5208 14.4856 12.7712 14.2073 12.7712 13.8641C12.7712 11.7067 10.9688 9.9577 7.28552 9.9577C3.60225 9.9577 1.7998 11.7067 1.7998 13.8641C1.7998 14.2073 2.05022 14.4856 2.35913 14.4856ZM9.34266 5.5713C9.34266 6.70743 8.42165 7.62845 7.28552 7.62845C6.14939 7.62845 5.22838 6.70743 5.22838 5.5713C5.22838 4.43517 6.14939 3.51416 7.28552 3.51416C8.42165 3.51416 9.34266 4.43517 9.34266 5.5713Z",
    stroke: "#D7DFE9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGovernorPersonal);
export default __webpack_public_path__ + "static/media/IconGovernorPersonal.24b40a52aa7a16a687c8a2060a3c009c.svg";
export { ForwardRef as ReactComponent };